import React, { Fragment, useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { useLocation } from 'react-router-dom'
import {
  HeaderNavigation,
  HeaderMenu,
  HeaderMenuItem,
  SideNavItems,
  SideNavLink,
  HeaderSideNavItems
} from 'carbon-components-react'
import SideNavMenu from '../SideNavbar/SideNavMenu'
import { NavMenu } from './components/NavMenu'
import { ItemMenu } from './components/ItemMenu'
import { uniqueId } from 'lodash'
import { NAV_MENU } from './constant'
import './index.scss'
import useIsMobile from '../../useIsMobile'

const ProxyLink = (Component) =>
  React.forwardRef(({ navigate, ...props }, ref) => {
    return <Component ref={ref} {...props} />
  })

const components = {
  header: {
    Container: Fragment,
    Content: HeaderNavigation,
    contentProps: { 'aria-label': 'navigation', className: 'header' },
    Menu: HeaderMenu,
    Item: ProxyLink(HeaderMenuItem),
    Counter: () => null
  },
  sidebar: {
    Container: ({ fill, ...props }) => (
      <div className={cx('ublique-sidebar-navigation-items', { fill })}>
        <HeaderSideNavItems {...props} />
      </div>
    ),
    containerProps: { hasDivider: true },
    Content: SideNavItems,
    Menu: SideNavMenu,
    Item: ProxyLink(SideNavLink),
    Counter: ({ length }) => <div className='sidenavlink-counter'>{length}</div>
  }
}

function Navigation({
  type,
  items,
  isSideNavExpanded,
  onClickSideNavExpand,
  onNavigate,
  sidebarSectionExpanded,
  setSidebarSectionExpanded,
  enableDragAndDrop,
  getMapModelByDragAndDrop,
  ...props
}) {
  const dragElement = useRef()
  const dragOverElemet = useRef()
  const dropGroup = useRef()
  const [listMenu, setListMenu] = useState(items.map((el) => el))
  const [mapModelList, setMapModelList] = useState([])

  const [key, setKey] = useState()

  const { pathname } = useLocation()

  const Components = components[type]

  const isMobile = useIsMobile()

  const setOrderToMapModel = (groupItems) => {
    let idx = 0
    return groupItems?.map((group) => {
      return {
        group: group.name,
        wts: group.items?.map((wt) => {
          return { type: wt.type, order: idx++ }
        })
      }
    })
  }

  useEffect(() => {
    // set map only if drag and drop is active
    if (enableDragAndDrop) getMapModelByDragAndDrop(mapModelList)
  }, [mapModelList])

  useEffect(() => {
    if (!enableDragAndDrop) setListMenu(items.map((el) => el))
  }, [items])

  if (!Components || !items || !items.length) return null
  const { Container, Content } = Components
  const { containerProps = {}, contentProps = {} } = Components

  const onClickItem = (item) => {
    if (type !== 'sidebar' && item.sidebar && !isSideNavExpanded) {
      onClickSideNavExpand()
    }
    if (item.onClick) {
      item.onClick()
    }
    if (onNavigate) {
      onNavigate(item)
    }

    if (onClickSideNavExpand) {
      isMobile && onClickSideNavExpand()
    }
  }

  /* group callback */
  const dragStartMenu = (e, position) => {
    // e.target.style.backgroundColor = color;
    dragElement.current = position
  }

  const dragEnterMenu = (e, position, group) => {
    dragOverElemet.current = position
    dropGroup.current = group
  }

  /* wt callback */
  const dragStartItem = (e, position) => {
    // e.target.style.backgroundColor = color;
    dragElement.current = position
  }

  const dragEnterItem = (e, position, group) => {
    dragOverElemet.current = position
    dropGroup.current = group
  }

  /* common callback diff by typeComp */
  const dropMenu = (e, index, typeComp, group) => {
    if (typeComp === NAV_MENU) {
      // moving group
      const copyListMenu = [...listMenu]
      const dragItemContent = copyListMenu[dragElement.current]
      copyListMenu.splice(dragElement.current, 1)
      copyListMenu.splice(dragOverElemet.current, 0, dragItemContent)
      dragElement.current = null
      dragOverElemet.current = null

      setListMenu(copyListMenu)
      setMapModelList(setOrderToMapModel(copyListMenu))
    } else {
      // moving wt

      /// check if wt is in his group
      if (group !== dropGroup.current) return

      const list = listMenu
      const menu = list[index]
      const copyListItems = menu.items

      const dragItemContent = copyListItems[dragElement.current]
      copyListItems.splice(dragElement.current, 1)
      copyListItems.splice(dragOverElemet.current, 0, dragItemContent)
      dragElement.current = null
      dragOverElemet.current = null

      const newMenu = { ...listMenu[index], items: copyListItems }
      list[index] = newMenu
      setListMenu(list)
      setMapModelList(setOrderToMapModel(list))
      setKey(uniqueId)
    }
  }

  return (
    <Container {...containerProps} {...props}>
      <Content {...contentProps} {...props}>
        {listMenu.map((item, index) => {
          return item.items
            ? item.onlyGroupLink
              ? ItemMenu(
                  item.items[0],
                  item.items[0].headerGroup,
                  item.onlyGroupLink,
                  Components,
                  onClickItem,
                  type,
                  pathname,
                  isSideNavExpanded,
                  index,
                  null,
                  null,
                  null,
                  0,
                  enableDragAndDrop
                )
              : (item.header || isSideNavExpanded || !isMobile) &&
                NavMenu(
                  key,
                  item,
                  dragStartMenu,
                  dragEnterMenu,
                  dropMenu,
                  index,
                  type,
                  pathname,
                  sidebarSectionExpanded,
                  setSidebarSectionExpanded,
                  isSideNavExpanded,
                  Components,
                  onClickItem,
                  dragStartItem,
                  dragEnterItem,
                  enableDragAndDrop
                )
            : ItemMenu(
                item,
                null,
                null,
                Components,
                onClickItem,
                type,
                pathname,
                isSideNavExpanded,
                index,
                null,
                null,
                null,
                0,
                enableDragAndDrop
              )
        })}
      </Content>
    </Container>
  )
}

Navigation.propTypes = {
  type: PropTypes.oneOf(['header', 'sidebar']),
  items: PropTypes.array
}

export default React.memo(Navigation)
